module.exports = __webpack_public_path__ + "img/thb.605ef9fd.svg";